const DEFAULT_QUIZ_SERVER_BASE_URL = 'https://dev-quiz-api.zep.us';

type AiServerRequestHeaderValues = {
  token?: string | null;
  serverName?: string | null;
  fingerprintId?: string | null;
};

export const getConfiguredAiServerBaseUrl = () => {
  return process.env['NEXT_PUBLIC_AI_SERVER_BASEURL'];
};

/**
 * 공개 도메인에서 깎아낸 이름 → AI 서버가 아는 **정규 슬롯명**.
 *
 * AI 서버는 `X-Quiz-Server-Name` 으로 클러스터 내부 주소를 만든다:
 *   `dev-1` → `http://dev-1-zep-quiz.dev-1.svc.cluster.local:9000`
 * 그래서 이름이 맵에 없으면 주소가 `None` 이 되고, 인증 프로필 조회가
 * `UnsupportedProtocol` 로 터져 **503 `USAGE_UNAVAILABLE`** 이 된다.
 *
 * dev-1 슬롯만 도메인 네이밍이 예외다 — `dev-1-quiz-api` 가 아니라 **`dev-quiz-api`** 를 쓴다.
 * 그래서 URL 파생이 `dev` 를 만들고, 그 이름은 AI 서버 맵에 없다. 여기서 보정한다.
 *
 * 실측(2026-08-06, otel_traces `dev-1-zep-quiz-ai`):
 *   dev-1 → http://dev-1-zep-quiz.dev-1.svc.cluster.local:9000/api/auth/profile  ✅
 *   dev-5 → http://dev-5-zep-quiz.dev-5.svc.cluster.local:9000/api/auth/profile  ✅
 *   dev   → /None/api/auth/profile   UnsupportedProtocol                          🔴
 *
 * ⚠️ HTTP 응답으로는 진단이 안 된다 — 맵에 있든 없든 최종 응답이 똑같이
 * 503 `USAGE_UNAVAILABLE` 이라 트레이스를 봐야 갈린다.
 */
const CANONICAL_SERVER_NAME_BY_DOMAIN_ALIAS: Record<string, string> = {
  dev: 'dev-1',
};

export function extractServerName(
  zepServerApiUrl = process.env['NEXT_PUBLIC_SERVER_BASEURL'] ??
    DEFAULT_QUIZ_SERVER_BASE_URL,
) {
  const derived = zepServerApiUrl.split('-quiz-api')[0].split('//')[1] ?? '';
  return CANONICAL_SERVER_NAME_BY_DOMAIN_ALIAS[derived] ?? derived;
}

export const createAiServerRequestHeaders = ({
  token,
  serverName,
  fingerprintId,
}: AiServerRequestHeaderValues) => {
  const headers: Record<string, string> = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (serverName) {
    headers['X-Quiz-Server-Name'] = serverName;
  }

  if (fingerprintId) {
    headers['X-Fingerprint-Id'] = fingerprintId;
  }

  return headers;
};
